'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const designSystem = require('@zapier/design-system');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const popover = "_popover_17e0w_1";
const styles = {
	popover: popover
};

const PopoverContext = React.createContext({});
const Popover = (props) => {
  const [contextProps] = reactAriaComponents.useContextProps(props, null, PopoverContext);
  const { className, size = "medium", style } = contextProps, otherProps = tslib_es6.__rest(contextProps, ["className", "size", "style"]);
  return React__default.default.createElement(reactAriaComponents.Popover, Object.assign({}, otherProps, { style: Object.assign(Object.assign({}, style), { "--popover-shadow": designSystem.Shadows.elevation20 }), className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.popover, className], renderProps), "data-size": size }));
};

exports.Popover = Popover;
exports.PopoverContext = PopoverContext;
//# sourceMappingURL=Popover.cjs.js.map
